import React from 'react'
import { Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  chip: {
    fontSize: 11,
    fontWeight: 600,
    height: 24,
    borderRadius: 4,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  published: {
    backgroundColor: '#E8F5E9',
    color: '#2E7D32',
    border: '1px solid #A5D6A7',
  },
  pending_review: {
    backgroundColor: '#FFF8E1',
    color: '#F57F17',
    border: '1px solid #FFE082',
  },
  draft: {
    backgroundColor: '#E3F2FD',
    color: '#1565C0',
    border: '1px solid #90CAF9',
  },
  blocked: {
    backgroundColor: '#FFEBEE',
    color: '#C62828',
    border: '1px solid #EF9A9A',
  },
  private: {
    backgroundColor: '#F5F5F5',
    color: '#616161',
    border: '1px solid #E0E0E0',
  },
}))

const STATUS_CONFIG = {
  // GraphQL enum values (uppercase with underscores)
  DRAFT: {
    label: 'Draft',
    className: 'draft',
  },
  PENDING_REVIEW: {
    label: 'Pending Review',
    className: 'pending_review',
  },
  PUBLISHED: {
    label: 'Published',
    className: 'published',
  },
  BLOCKED: {
    label: 'Blocked',
    className: 'blocked',
  },
  // Legacy values for backwards compatibility
  Published: {
    label: 'Published',
    className: 'published',
  },
  PendingApproval: {
    label: 'Pending Review',
    className: 'pending_review',
  },
  Private: {
    label: 'Private',
    className: 'private',
  },
}

const StatusChip = ({ status }) => {
  const classes = useStyles()
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.DRAFT

  return (
    <Chip
      label={config.label}
      size="small"
      className={`${classes.chip} ${classes[config.className]}`}
    />
  )
}

export default StatusChip
